import React from "react";

const SaleSummaryHeader = ({
    status,
    balance,
    balanceAmount,
    orderDate,
    purchaseOrder,
    customer,
}) => {
    const statusValue = status || "—";
    const statusTone =
        statusValue === "Completed"
            ? "success"
            : statusValue === "Pending Paint"
              ? "warning"
              : "default";

    const balanceTone = balanceAmount > 0 ? "negative" : "positive";

    const items = [
        { label: "Customer", value: customer, tone: "customer" },
        { label: "Order Date / PO#", tone: "meta", orderDate, purchaseOrder },
        { label: "Status", value: statusValue, tone: statusTone },
        { label: "Balance", value: balance, tone: "balance", balanceTone },
    ];

    return (
        <section className="Sale-summary-header" aria-label="Sale summary">
            {items.map((item) => (
                <div
                    key={item.label}
                    className={`Sale-summary-item ${item.tone ? `tone-${item.tone}` : ""}`}
                >
                    <p className="detail-field-label">{item.label}</p>
                    {item.label === "Status" ? (
                        <p className={`Sale-summary-value Sale-status-pill tone-${statusTone}`}>
                            {item.value || "—"}
                        </p>
                    ) : item.tone === "meta" ? (
                        <div className="Sale-summary-meta">
                            <p className="Sale-summary-meta-row">
                                <span className="Sale-summary-meta-key">Date:</span>{" "}
                                {item.orderDate || "—"}
                            </p>
                            <p className="Sale-summary-meta-row">
                                <span className="Sale-summary-meta-key">PO#:</span>{" "}
                                {item.purchaseOrder || "—"}
                            </p>
                        </div>
                    ) : item.label === "Balance" ? (
                        <p className={`Sale-summary-value tone-${item.balanceTone}`}>
                            {item.value || "—"}
                        </p>
                    ) : (
                        <p className="Sale-summary-value">{item.value || "—"}</p>
                    )}
                </div>
            ))}
        </section>
    );
};

export default SaleSummaryHeader;
